import EpDevPUtils from "../../EpDevPUtils";
import { TOrganizationsApiGetConfigPathParams } from "../types";

const ORGANIZATIONS = "organizations";
const CONFIG = "config";

export class EpDevPOrganizationsApiRoutesFactory {

  public static getSubRouteBase = (): string => {
    return `/${ORGANIZATIONS}`;
  }
  public static getSubRouteList = (): string => { 
    return EpDevPOrganizationsApiRoutesFactory.getSubRouteBase();
  }
  public static getSubRouteGetConfig = (): string => { 
    return EpDevPOrganizationsApiRoutesFactory.getSubRouteBase()
    + `/:${EpDevPUtils.nameOf<TOrganizationsApiGetConfigPathParams>("organizationId")}`
    + `/${CONFIG}`;
  }
}

export class EpDevPOrganizationsApiPathsFactory {

  private static basePath(): string { return `/${ORGANIZATIONS}`; }

  public static createListPath(): string {
    return this.basePath();
  }

  public static createGetConfigPath({ organizationId }:{ 
    organizationId: string;
  }): string {
    return `${this.basePath()}/${organizationId}/${CONFIG}`;
  }

}
